import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux"

import {
    Grid, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TablePagination, Fab, makeStyles
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { UserActions } from "./actions/user"
import { UserForm } from "./components/UserForm"
import { RoleActions } from "./actions/role"

const useStyles = makeStyles(theme => ({
    field: {
        'height': '100%'
    },
    data: {
        'height': 'calc(100% - 52px)',
        'width': '100%'
    },
    item: {
        'width': '100%'
    },
    table: {
        'height': '100%'
    },
    fab: {
        'margin': '0',
        'top': 'auto',
        'right': '90px',
        'bottom': '25px',
        'left': 'auto',
        'position': 'fixed'
    }
}))

const columns = [
    {
        id: 'login',
        label: 'Имя пользователя',
        align: 'left',
        format: value => value.toLocaleString()
    }
]

export const User = (props) => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const {users} = useSelector(state => state.user)
    const [user, setUser] = useState(null)
    const [dialog, setDialog] = useState(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [loading, setLoading] = useState(false)
    const [initialize, setInitialize] = useState(false)

    useEffect(() => {
        const getUsers = async () => {
            if (!initialize) {
                await dispatch(RoleActions.roles())
            }
            return await dispatch(UserActions.users({page: page + 1, limit: rowsPerPage}))
        }

        if (!loading) {
            getUsers().then(_ => {
                setLoading(true)
                setInitialize(true)
            })
        }
    }, [dispatch, initialize, loading, page, rowsPerPage])

    const handleDelete = (id) => {
        return dispatch(UserActions.remove(id)).then(
            () => {
                setLoading(false)
            }
        )
    }

    const handleSave = (values, id = null) => {
        if (id) {
            return dispatch(UserActions.save(id, values))
        } else {
            return dispatch(UserActions.add(values)).then(
                () => {
                    setLoading(false)
                }
            )
        }
    }

    const handleClose = () => {
        setUser(null)
        setDialog(false)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
        setLoading(false)
    }

    const handleChangeRowsPerPage = (event) => {
        setPage(0)
        setRowsPerPage(+event.target.value)
        setLoading(false)
    }

    return (
        <Grid container direction="column" justify="space-between" alignItems="center" className={classes.field}>
            <Grid item className={classes.data}>
                <TableContainer className={classes.table}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map(column => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.data.map(item => {
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={item.id}
                                        onClick={() => {
                                            setUser(item)
                                            setDialog(true)
                                        }}
                                    >
                                        <TableCell align="left">
                                            { item.login }
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item className={classes.item}>
                <TablePagination
                    rowsPerPageOptions={ [10, 25, 100] }
                    component="div"
                    count={ users.data.length ? users.meta.total : 0 }
                    rowsPerPage={ rowsPerPage }
                    page={ page }
                    onChangePage={ handleChangePage }
                    onChangeRowsPerPage={ handleChangeRowsPerPage }
                />
            </Grid>
            <Fab size="medium" color="primary" aria-label="Добавить" className={ classes.fab } onClick={() => { setDialog(true) }}>
                <AddIcon />
            </Fab>
            { dialog && <UserForm user={ user } open={ dialog } handleClose={ handleClose } handleDelete={ handleDelete } handleSave={ handleSave } /> }
        </Grid>
    )
}
